import { render, staticRenderFns } from "./SalesmanDonationStatistics.vue?vue&type=template&id=4af90eb2&"
import script from "./SalesmanDonationStatistics.vue?vue&type=script&lang=js&"
export * from "./SalesmanDonationStatistics.vue?vue&type=script&lang=js&"
import style0 from "./SalesmanDonationStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports